export const detectMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  return {
    isMobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase()),
    isAndroid: /android/i.test(userAgent),
    isIOS: /iphone|ipad|ipod/i.test(userAgent),
    isSmallScreen: window.innerWidth <= 768,
    userAgent: userAgent
  };
};

export const shouldShowMobileLanding = () => {
  const { isMobile, isSmallScreen } = detectMobileDevice();
  const bypassMobile = localStorage.getItem('bypassMobileLanding');
  
  return isMobile && isSmallScreen && !bypassMobile;
};

export const getAppStoreUrl = (platform) => {
  const urls = {
    ios: 'https://apps.apple.com/us/app/siki-io/id1564875912',
    android: 'https://play.google.com/store/apps/details?id=io.siki.app'
  };
  
  return urls[platform] || null;
};

export const setMobileBypass = (bypass = true) => {
  if (bypass) {
    localStorage.setItem('bypassMobileLanding', 'true');
  } else {
    localStorage.removeItem('bypassMobileLanding');
  }
};